var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bungkus"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    staticClass: "btn btn-block btn-info",
    attrs: {
      "target": "_blank",
      "href": _vm.$http.options.base + '/' + 'file' + '/' + 'pdf' + '/' + 'laporan2022.pdf'
    }
  }, [_vm._m(6)])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\logo-kementrian.jpeg",
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 mt-5"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "color": "white"
    }
  }, [_vm._v("LAPORAN KINERJA KANTOR PELAYANAN UTAMA BEA DAN CUKAI TIPE B BATAM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\bea-cukai-squared.webp",
      "width": "90%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\foto-kantor.jpeg",
      "width": "95%"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 justify-content-center"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "color": "white"
    }
  }, [_vm._v("UNDUH LAPORAN")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "70px"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down",
    staticStyle: {
      "color": "white"
    }
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("DOWNLOAD "), _c('i', {
    staticClass: "fa fa-download"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2122faf4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pengumuman.vue
// module id = 403
// module chunks = 0